@if (!billingService.activeSubscription?.hasAppAccess || isPlansPage()) {
  <router-outlet></router-outlet>
} @else {
  <div hlmSidebarWrapper>
    <hlm-sidebar collapsible="icon">
      <hlm-sidebar-header>
        <ul hlmSidebarMenu>
          <li hlmSidebarMenuItem>
            <a hlmSidebarMenuButton size="lg" [routerLink]="landingPath">
              <div class="flex aspect-square size-8 items-center justify-center">
                <img alt="Regentis" class="size-4" src="assets/img/logo_icon.png"/>
              </div>
              <hlm-separator orientation="vertical" class="data-vertical:h-4 data-vertical:self-center group-data-[collapsible=icon]:hidden" />
              <div class="grid flex-1 text-left text-sm leading-tight">
                <span class="truncate font-medium">{{ organizationName() }}</span>
              </div>
            </a>
          </li>
        </ul>
      </hlm-sidebar-header>

      <hlm-sidebar-content>
        @if (mainItems().length) {
          <hlm-sidebar-group>
            <ul hlmSidebarMenu>
              @for (item of mainItems(); track item.id) {
                <li hlmSidebarMenuItem>
                  <a hlmSidebarMenuButton
                     [routerLink]="item.link"
                     routerLinkActive
                     #rla="routerLinkActive"
                     [isActive]="rla.isActive"
                     [tooltip]="item.title">
                    <ng-icon [name]="item.icon" />
                    <span>{{ item.title }}</span>
                  </a>
                  @if (item.id === 'inbox' && inboxCount()) {
                    <div hlmSidebarMenuBadge>{{ inboxCount() }}</div>
                  }
                </li>
              }
            </ul>
          </hlm-sidebar-group>
        }

        @if (settingsItems().length) {
          <hlm-sidebar-group>
            <ul hlmSidebarMenu>
              <hlm-collapsible [(expanded)]="settingsExpanded" class="group/collapsible">
                <li hlmSidebarMenuItem>
                  <button hlmSidebarMenuButton hlmCollapsibleTrigger tooltip="Settings">
                    <ng-icon name="lucideSettings2" />
                    <span>Settings</span>
                    <ng-icon name="lucideChevronRight"
                             class="ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
                  </button>

                  <hlm-collapsible-content>
                    <ul hlmSidebarMenuSub>
                      @for (item of settingsItems(); track item.id) {
                        <li hlmSidebarMenuSubItem>
                          <a hlmSidebarMenuSubButton
                             [routerLink]="item.link"
                             routerLinkActive
                             #rla="routerLinkActive"
                             [isActive]="rla.isActive">
                            <span>{{ item.title }}</span>
                          </a>
                        </li>
                      }
                    </ul>
                  </hlm-collapsible-content>
                </li>
              </hlm-collapsible>
            </ul>
          </hlm-sidebar-group>
        }
      </hlm-sidebar-content>

      <hlm-sidebar-footer>
        <ul hlmSidebarMenu>
          @if (billingService.activeSubscription?.isTrialing) {
            <li hlmSidebarMenuItem>
              <a hlmSidebarMenuButton routerLink="/plans" [tooltip]="trialLabel()">
                <ng-icon name="lucideClock" />
                <span>{{ trialLabel() }}</span>
              </a>
            </li>
          }
          <app-notifications />
        </ul>
        <app-nav-user />
      </hlm-sidebar-footer>
    </hlm-sidebar>

    <!-- A full-bleed page (the designer) is held to the window and scrolls inside its own panels. -->
    <main hlmSidebarInset class="min-w-0" [class.h-svh]="fullBleed()">
      <app-page-header />
      <div class="flex flex-1 flex-col" [class]="fullBleed() ? 'min-h-0' : 'p-4 pt-0'">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
}

<hlm-toaster />
